// src/pages/offlineSales/terminal/components/SessionGate.jsx
import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import { openSession } from '../../../../services/api/offlineSales/cashierSessions';
import { useAlert } from '../../../../contexts/AlertContext';
import styles from '../OfflineSalesTerminal.module.css';

const SessionGate = ({ shopId, onSessionOpened }) => {
  const { t } = useLocalization();
  const { error } = useAlert();
  const [openingCash, setOpeningCash] = useState('');
  const [loading, setLoading] = useState(false);

  const handleOpen = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const result = await openSession({ shopId: parseInt(shopId), openingCash: parseFloat(openingCash) || 0 });
      onSessionOpened(result.session);
    } catch (err) {
      error(err?.response?.data?.message || 'Failed to open session');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.sessionGate}>
      <div className={styles.sessionGateCard}>
        <div className={styles.sessionGateIcon}><Lock size={40} /></div>
        <h2>{t('pos.sessionRequired')}</h2>
        <p>{t('pos.sessionRequiredMsg')}</p>
        <form onSubmit={handleOpen} className={styles.sessionGateForm}>
          <label>{t('pos.openingCash')}</label>
          <input
            type="number"
            min="0"
            step="0.01"
            value={openingCash}
            onChange={e => setOpeningCash(e.target.value)}
            placeholder={t('pos.openingCashPlaceholder')}
            className={styles.sessionGateInput}
          />
          <button type="submit" disabled={loading} className={styles.sessionGateBtn}>
            {loading ? '...' : t('pos.openSession')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SessionGate;
